<template>
  <div class="mx-4">
    <p
      v-if="prevRoute.name === 'PublicExport'"
      @click="$router.go(-1)"
      class="mb-4 font-opensans bg-gray-200 mx-4 p-2 cursor-pointer font-bold"
    >
      Terug naar export aanvragen
    </p>
    <p class="font-raleway font-bold text-2xl text-mi-blue-500 uppercase">
      Voorwaarden gebruik data DSA
    </p>
    <p class="mb-4 font-opensans">
      De DSA is open data en valt onder een
      <a rel="license" href="http://creativecommons.org/licenses/by-sa/4.0/"
        >Creative Commons Naamsvermelding-GelijkDelen 4.0
        Internationaal-licentie</a
      >.<br />
      Kort betekent dat dat het gebruik van data voor niet-commerciele en
      commerciele doeleinden is toegestaan, mits er gerefereerd wordt naar het
      databestand. Daarnaast is het toegestaan om de data door te ontwikkelen,
      te transformeren en producten te bouwen op basis van de data, mits deze
      producten onder dezelfde voorwaarden beschikbaar zijn.
    </p>
    <p class="mb-4 font-opensans">
      Daarnaast is het voor de verbetering van onze data-service van de DSA
      noodzakelijk dat we na een half jaar contact met alle aanvragers van data
      opnemen. Het doel hiervan is tweeledig. Ten eerste willen we nagaan of
      tijdens het gebruik van de data onvolledigheden aan het licht zijn
      gekomen, zodat we op basis daarvan de kwaliteit van de database kunnen
      verbeteren. Tot tweede is het voor het relevant houden van deze dienst van
      belang voor welke doeleinden de data gebruikt wordt en wat daar specifieke
      eisen voor zijn.
    </p>
    <p></p>
    <p
      class="font-raleway font-semibold text-xl text-mi-blue-500 uppercase mt-4"
    >
      Disclaimer
    </p>
    <p class="mb-4 font-opensans">
      Het Mulier Instituut kan niet verantwoordelijk worden gehouden voor enige
      informatie die middels deze website gevonden wordt. Het Mulier Instituut
      aanvaardt geen enkele aansprakelijkheid voor schade ontstaan uit het
      bezoeken van deze site of voor enige schade ontstaan uit verleende
      diensten, door gebruik van aangeboden of voor naar verwezen meta data
      waarnaar verwezen wordt. Het Mulier Instituut is niet aansprakelijk voor
      ongeoorloofde of onbelemmerde toegang tot gegevens die u via de datasets
      aanbiedt. Het Mulier Instituut garandeert niet dat de website foutloos of
      ononderbroken functioneert.
    </p>
    <p class="font-opensans">
      <a rel="license" href="http://creativecommons.org/licenses/by-sa/4.0/"
        ><img
          alt="Creative Commons-Licentie"
          style="border-width:0"
          src="https://i.creativecommons.org/l/by-sa/4.0/88x31.png"/></a
      ><br />Dit werk valt onder een
      <a rel="license" href="http://creativecommons.org/licenses/by-sa/4.0/"
        >Creative Commons Naamsvermelding-GelijkDelen 4.0
        Internationaal-licentie</a
      >.
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      prevRoute: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  }
};
</script>

<style></style>
